<template>
    <div class="conversation-chip" :class="{ selected }">
        <p class="title">{{ truncatedTitle }}</p>
        <p class="id">ID: {{ conversationId }}</p>
        <p class="created-at">Created At: {{ formattedCreatedAt }}</p>
        <p class="status">Status: {{ status }}</p>
        <p class="user-id">{{ userId }}</p>
    </div>
</template>

<script>
export default {
    props: {
        conversationId: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        createdAt: {
            type: String,
            required: true
        },
        status: {
            type: String,
            required: true
        },
        userId: {
            type: String,
            required: true
        },
        selected: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        formattedCreatedAt() {
            const date = new Date(this.createdAt);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${day}/${month}/${year} ${hours}:${minutes}`;
        },
        truncatedTitle() {
            let title = this.title || 'Untitled';
            let maxLength = 140;
            let firstWordMaxLength = 35;

            // Split the title into words
            let words = title?.split(/\s+/);

            // Process the first word
            if (words && words[0].length > firstWordMaxLength) {
                words[0] = words[0].slice(0, 32) + '...';
            }

            // Reconstruct the title
            title = words.join(' ');

            // Truncate the title if it exceeds maxLength
            if (title.length > maxLength) {
                title = title.slice(0, maxLength) + '...';
            }

            return title;
        }
    }
}
</script>

<style scoped>
.conversation-chip {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 12px 24px;
    background-color: transparent;
    border-radius: 0 6px 6px 0;
    cursor: pointer;
    margin-bottom: 12px;
    box-sizing: border-box;
    max-width: 90%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all .2s ease-in-out;
    color: #f0f0f0;
    background-color: #444;
}

.conversation-chip.selected {
    background-color: rgb(200, 200, 200);
    color: #a1344e;
    margin-bottom: 24px;
    align-self: flex-end;
    border-radius: 6px 0 0 6px;
    font-size: 14pt;
    border: 2px solid #1f1c1c;
    border-right: none;
    position: sticky;
    top: 0;
    flex-direction: column;
}

.conversation-chip.selected .conversation_id-p {
    color: #a1344e;
}



.conversation-chip:hover {
    background-color: #fff;
    color: #1f1c1c;
}


.conversation-title {
    font-weight: bold;
    line-height: 1;
}

.messages-number {
    margin-left: 4px;
    color: #888;
}

.selected .messages-number {
    margin-left: 4px;
    color: #eee;
}

.conversation_id-p {
    margin-top: 6px;
    font-size: 10pt;
    color: #eee;
}

.title {
    font-weight: bold;
    font-size: 13pt;
    margin-bottom: 12px;
    color: #000;
}

.id,
.created-at,
.user-id {
    font-size: 11pt;
}

.conversation-chip:not(.selected) .title {
    color: #eee;
}

.conversation-chip:not(.selected):hover .title {
    color: #1f1c1c;
}
</style>